import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import * as Variables from "../../shared/utils/variables";
import * as RoutePath from "../../shared/utils/routeLink";

import "./FooterComponent.scss";
import { homeUrl } from "../../shared/utils/apiEndPoints";
import { EmailIcon, FacebookIconFooter, InstagramIconFooter, LogoIcon, MapPinIcon, TiktokFooterIcon, WhatsappFooterIcon, YoutubeIconFooter } from "../../shared/component/svg/Icons";

class FooterComponent extends React.Component {
	ENV_NAME = this.props.ENV_NAME || "bhs";

	goToTnC = () => {
		window.open("https://" + homeUrl + RoutePath.TNC);
	};

	goToPrivacyPolicy = () => {
		window.open("https://" + homeUrl + RoutePath.PRIVACY_POLICY);
	};

	render() {
		return (
			<div className="container-fluid footer">
				<div className="footer-content container">
					<div className="footer-left">
						<div className="footer-social">
						<LogoIcon className="show-desktop" width="245" height="106"/> 
						<LogoIcon className="show-mobile" width="150" height="60"/> 
							<div className="footer-icon-wrapper">
								<a href="https://www.facebook.com/p/Portal-Sekolah-100077279562033/" className="cursor-pointer">
									<FacebookIconFooter fill="#337FFF" />
								</a>
								<a className="cursor-pointer" href="https://www.instagram.com/portalsekolah/">
									<InstagramIconFooter />
								</a>
								<a className="cursor-pointer" href="https://www.youtube.com/@portalsekolah">
									<YoutubeIconFooter />
								</a>
								<a className="cursor-pointer" href="https://www.tiktok.com/@portalsekolah">
									<TiktokFooterIcon />
								</a>
							</div>
						</div>
					</div>
						<div className="contacts-wrapper">
							<p className="mb-0 contacts-wrapper__title">{Variables.SITE_LINKS[this.ENV_NAME]}</p>
							<div className="contact-detail">
								<p className="contacts-wrapper__site" onClick={()=>this.props.history.push("/kampus")}>{Variables.COLLEGE[this.ENV_NAME]}</p>
							</div>
							<div className="contact-detail">
								<p className="contacts-wrapper__site" onClick={()=>this.props.history.push("/major")}>{Variables.MAJOR[this.ENV_NAME]}</p>
							</div>
							<div className="contact-detail">
								<p className="contacts-wrapper__site" onClick={()=>this.props.history.push("/beasiswa")}>{Variables.SCHOLARSHIP[this.ENV_NAME]}</p>
							</div>
							<div className="contact-detail">
								<p className="contacts-wrapper__site" onClick={()=>this.props.history.push("/karir")}>{Variables.CAREER[this.ENV_NAME]}</p>
							</div>
						</div>
						<div className="contacts-wrapper">
							<p className="mb-0 contacts-wrapper__title">{Variables.CONTACT_US[this.ENV_NAME]}</p>
							<div className="contact-detail">
								<MapPinIcon width="24" height="24" fill="#193560"/>
									<address className="contacts-wrapper__address">
										Kantor Utama (Main Office) Tokopedia Tower Lantai 35
										Jl. Prof. Dr. Satrio Kav. 11
										Jakarta Selatan 12950
									</address>
							</div>
								<div className="contact-detail">
								<EmailIcon fill="#193560"/>
									<a
										href={`mailto:support@${homeUrl}?subject=${Variables.MAIL_TO_SUBJECT[this.ENV_NAME]}`}
										target="_blank"
										rel="noopener noreferrer"
										className="cursor-pointer"
									>
										<p className="contacts-wrapper__email">{`support@${homeUrl}`}</p>
									</a>
								</div>			
								<div className="contact-detail">
									<WhatsappFooterIcon fill="#193560"/>
									<a href="https://wa.me/+628119539396" target="_blank" rel="noopener noreferrer" >
										<p className="cursor-pointer contacts-wrapper__phonenum">(+62) 811-9539-396</p>
									</a>
								</div>
						</div>
				</div>

				{/* Subfooter nonactive */}
				{/* <div className="row">
					<div className="col-12 subFooter">
						<div className="copyright">&copy; {new Date().getFullYear()} Portal Sekolah</div>
						<div className="TnC">
							<ul>
								<li onClick={this.goToPrivacyPolicy}>
									{Variables.PRIVACY_POLICY[this.ENV_NAME]} <span>|</span>
								</li>
								<li onClick={this.goToTnC}>{Variables.TNC[this.ENV_NAME]}</li>
							</ul>
						</div>
					</div>
				</div> */}
			</div>
		);
	}
}
const mapStateToProps = (state) => {
	return { ENV_NAME: state.auth.selectedEnvironment || "bhs" };
};
export default connect(mapStateToProps)(withRouter(FooterComponent));
